<template>
  <header class="main-header">
    <!-- Logo -->
    <router-link to="/dashboard" class="logo">
      <!-- mini logo for sidebar mini 50x50 pixels -->
      <span class="logo-mini"><b>M</b>A</span>
      <!-- logo for regular state and mobile devices -->
      <span class="logo-lg"><img class="logo-ma" src="/static/img/Logo-MA-White.png" alt="logo"/></span>
    </router-link>
    <!-- Header Navbar: style can be found in header.less -->
    <nav class="navbar navbar-static-top">
      <!-- Sidebar toggle button-->
      <a class="sidebar-toggle" data-toggle="offcanvas" role="button" @click="collapse">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </a>
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <transition name="fade">
            <li v-if="klook.balance && klook.currency">
              <h4 class="navbar-text text-white">
                <span class="label label-info text-uppercase">
                  Balance
                </span>
                <span>
                  {{ klook.currency }} {{ klook.balance }}
                </span>

                <button class="reload">
                  <i class="fa fa-fw fa-refresh"
                    aria-hidden="true"
                    :class="{ 'fa-spin': isLoading }"
                    @click="getBalance"></i>
                </button>
              </h4>
            </li>
          </transition>

          <!-- User Account: style can be found in dropdown.less -->
          <li class="dropdown user user-menu">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <img src="/static/img/user2-160x160.svg" class="user-image" alt="User Image">
              <span class="hidden-xs">{{ user.name }}</span>
            </a>
            <ul class="dropdown-menu">
              <!-- User image -->
              <li class="user-header">
                <img src="/static/img/user2-160x160.jpg" class="img-circle" alt="User Image">
                <p>
                  {{ user.name }} as {{ user.role }}
                </p>
              </li>
              <!-- Menu Footer-->
              <li class="user-footer">
                <div class="pull-left">
                  <router-link to="/profile">Profile</router-link>
                </div>
                <div class="pull-right">
                  <a class="btn btn-default btn-flat" @click.prevent="logout">Sign out</a>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import Common from '@/mixins/Common';

export default {
  name: 'DashboardHeader',

  data() {
    return {
      isLoading: false,
      klook: {
        balance: 0,
        currency: null,
      },
    };
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
  },

  mixins: [Common],

  methods: {
    getBalance() {
      if (this.isLoading) return;

      this.isLoading = true;

      this.axios.get('/klook/balance')
        .then((response) => {
          const { balance, currency } = response.data;

          this.klook = {
            balance: this.digitGrouping(balance),
            currency,
          };

          this.isLoading = false;
        })
        .catch((error) => {
          console.log('Failed fetching balance', error);
        });
    },

    collapse() {
      $('body').toggleClass('sidebar-collapse');

      const width = $(window).width();
      if (width < 480) {
        $('body').toggleClass('sidebar-open');
      }
    },

    logout() {
      this.$store.commit('REMOVE_TOKEN');
      this.$store.commit('REMOVE_USER');

      if (window.localStorage) {
        window.localStorage.removeItem('token');
      }

      this.$router.push('/login');
    },
  },

  mounted() {
    setTimeout(() => {
      this.getBalance();
    }, 1500);
  },
};
</script>

<style lang="scss" scoped>
  .navbar-text {
    color: white;
    vertical-align: middle;
    height: 35px;
    display: flex;
    align-items: center;

    span {
      display: inline-block;
      vertical-align: middle;
      font-size: 1.25rem;

      &.label {
        margin-right: 0.5rem;
        font-size: 1.125rem;
        font-weight: bold;
      }
    }

    .reload {
      border: none;
      background: none;
      font-size: 1.25rem;

      &:hover {
        color: #f39c12;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partials/Header.vue